/**
 * A line at the top of the app for administrators when the Entra secret is
 * about to expire or has: the one failure that takes every Microsoft
 * sign-in down at once, and the one nobody notices until it does.
 */

import { Link } from 'react-router-dom';
import type { SsoHealth } from '../features/org/useOrgHealth';
import styles from '../shared/Page.module.css';

export function bannerText(h: SsoHealth | null | undefined): string | null {
  if (!h) return null;
  const when = h.secretExpiresAt ? h.secretExpiresAt.slice(0, 10) : null;
  if (h.status === 'expired') return `The single sign-on secret expired${when ? ` on ${when}` : ''}. Microsoft sign-in is down for everyone until it is replaced.`;
  if (h.status === 'expiring') return `The single sign-on secret expires ${h.daysLeft === 0 ? 'today' : h.daysLeft === 1 ? 'tomorrow' : `in ${h.daysLeft} days`}${when ? ` (${when})` : ''}. Replace it before then.`;
  return null;
}

export function SsoHealthBanner({ health }: { health: SsoHealth | null | undefined }) {
  const text = bannerText(health);
  if (!text) return null;
  return (
    <div className={`${styles.notice} ${health?.status === 'expired' ? styles.noticeDanger : styles.noticeWarn}`} role="status" style={{ margin: '0 0 var(--sp-4)' }}>
      {text} <Link to="/settings">Open Settings</Link>.
    </div>
  );
}
